<script setup lang="ts"></script>

<template>
  <div class="skeleton-Reviews">
    <div class="flex flex-col gap-6 md:flex-row">
      <div class="w-full md:w-2/6">
        <div
          class="flex items-center gap-4 md:flex-col md:items-start md:gap-0"
        >
          <div class="mb-4 flex justify-center md:w-full">
            <SkeletonAnimatedPlaceholder
              height="200px"
              width="200px"
              borderRadius="50%"
            />
          </div>

          <div class="flex w-full flex-col">
            <h2 class="md:mb-3">
              <SkeletonAnimatedPlaceholder height="16px" width="60%" />
            </h2>
            <span>
              <SkeletonAnimatedPlaceholder height="16px" width="50%" />
            </span>
          </div>
        </div>

        <p class="mb-6 mt-4">
          <SkeletonAnimatedPlaceholder height="16px" width="70%" />
        </p>

        <div
          class="flex flex-col gap-3 bg-grey-main pb-4 pl-3 pr-4 pt-3 md:pb-10"
        >
          <p class="mb-2">
            <SkeletonAnimatedPlaceholder height="16px" width="60%" />
          </p>

          <div
            v-for="(i, index) in 5"
            :key="`star${index}`"
            class="flex items-center justify-between"
          >
            <UtilsStars :size="5" :stars="5 - index" />
            <SkeletonAnimatedPlaceholder height="16px" width="50%" />
          </div>
        </div>
      </div>
      <div class="w-full md:w-4/6">
        <div class="flex flex-col gap-6">
          <div
            class="
              flex flex-col
              gap-6
              md:flex-row
              md:items-center
              md:justify-between
              md:gap-7
            "
          >
            <div class="flex flex-shrink-0 items-center gap-4">
              <span class="ml-2">
                <SkeletonAnimatedPlaceholder height="16px" width="20%" />
              </span>
            </div>
          </div>

          <div v-for="i in 3" class="flex flex-col gap-4 pb-2">
            <div class="flex items-center gap-2">
              <SkeletonAnimatedPlaceholder height="16px" width="10%" />
              <SkeletonAnimatedPlaceholder height="16px" width="10%" />
            </div>

            <div class="flex justify-between">
              <SkeletonAnimatedPlaceholder height="16px" width="10%" />
              <SkeletonAnimatedPlaceholder height="16px" width="10%" />
            </div>

            <SkeletonAnimatedPlaceholder height="80px" width="100%" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
